<template>
  <div :class="$style['scroll-indicator']" />
</template>

<script>
export default {
  name: 'ScrollIndicator',
}
</script>

<style lang="less" module>
.scroll-indicator {
  position: absolute;
  z-index: 2;

  &::before {
    .size(100%);

    content: '';
    display: block;
    animation: scrollDown 2s ease-in-out infinite;
  }

  // 滚动指示器动画
  @keyframes scrollDown {
    0%,
    20% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(0.15rem);
    }
    80%,
    100% {
      transform: translateY(0);
    }
  }
}

// 横屏
:global(.landing-screen-landscape) {
  .scroll-indicator {
    .size(0.32rem, 1.81rem);

    &::before {
      background: url('./images/scroll-indicator.png') no-repeat center;
      background-size: 100% 100%;
    }
  }
}

// 竖屏
:global(.landing-screen-portrait) {
  .scroll-indicator {
    .size(0.43rem, 1.54rem);

    &::before {
      background: url('./images/scroll-indicator-small.png') no-repeat center;
      background-size: 100% 100%;
    }
  }
}
</style>
